import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpParams
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  constructor() { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    let headers = request.headers;
    const token = getJwtToken();

    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    } else if (isInvalidAuthorization(headers.get('Authorization'))) {
      headers = headers.delete('Authorization');
    }

    if (isFormData(request.body)) {
      headers = headers.delete('Content-Type');
    } else if (shouldSetJsonContentType(request.body) && !headers.has('Content-Type')) {
      headers = headers.set('Content-Type', 'application/json');
    }

    const clonedRequest = request.clone({ headers });

    return next.handle(clonedRequest);
  }
}

function getJwtToken(): string | null {
  const token = localStorage.getItem('token');

  if (!token || token === 'null' || token === 'undefined') {
    return null;
  }

  return token;
}

function isFormData(body: unknown): body is FormData {
  return typeof FormData !== 'undefined' && body instanceof FormData;
}

function shouldSetJsonContentType(body: unknown): boolean {
  if (body == null || isFormData(body)) {
    return false;
  }

  if (
    body instanceof HttpParams ||
    body instanceof ArrayBuffer ||
    body instanceof URLSearchParams ||
    (typeof Blob !== 'undefined' && body instanceof Blob) ||
    typeof body === 'string'
  ) {
    return false;
  }

  return typeof body === 'object';
}

function isInvalidAuthorization(authorization: string | null): boolean {
  if (!authorization) {
    return false;
  }

  const normalizedAuthorization = authorization.trim().toLowerCase();

  return normalizedAuthorization === 'bearer null' ||
    normalizedAuthorization === 'bearer undefined' ||
    normalizedAuthorization === 'bearer';
}